import { axios } from '@Root/API'

export const get = (studyProgrammeId, supervisorAllocationId) => {
	return axios.get(`course-session/${studyProgrammeId}/supervisor-allocation/${supervisorAllocationId}`)
}
